import React, { FunctionComponent } from 'react';
import Button, { ButtonStyling } from 'components/button/button';
import CheckList from 'components/check-list/check-list';
import { CtaBox, CtaBoxActions, CtaBoxContent, CtaBoxMedia, CtaBoxText } from 'components/cta-box';
import { CtaBoxColor } from 'components/cta-box/cta-box';
import HeroTitle from 'components/hero-title/hero-title';
import { JoinHivesProps } from './join-hives';

const JoinHivesMobile: FunctionComponent<JoinHivesProps> = ({ title, text, bullets, cta }) => {
    return (
        <CtaBox color={CtaBoxColor.HIVES}>
            <div className="hives-cta-box">
                <CtaBoxMedia>
                    <HeroTitle text={title} />
                </CtaBoxMedia>

                <CtaBoxText>{text}</CtaBoxText>

                <CtaBoxActions>
                    <Button text={cta.text} href={cta.url} styling={ButtonStyling.CELL} />
                </CtaBoxActions>

                <CtaBoxContent>
                    <CheckList items={bullets} />
                </CtaBoxContent>

                <CtaBoxActions>
                    <Button text={cta.text} href={cta.url} styling={ButtonStyling.CELL} />
                </CtaBoxActions>
            </div>
        </CtaBox>
    );
};

export default JoinHivesMobile;
